var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, " #particles-js{\r\n        width: 100%;\r\n        height: 100%;\r\n        position: relative;\r\n        background-image: url(" + escape(require("../img/f18a52d.png")) + ");\r\n\t\tbackground-color: #476EF6;\r\n        background-position: 50% 50%;\r\n        background-size: cover;\r\n        background-repeat: no-repeat;\r\n\t\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n    }\r\n", ""]);

// exports
